const projectsData = [
  {
    id: 0,
    title: "Weather You Like It or Not",
    headline: "A Weather Lookup App",
    caption: "React, Firebase Realtime Database",
    image: "react-weather-app",
    description:
      "A web application to look up the current weather, allowing you to search today's weather or the forecast for the next five days. Built with React and OpenWeatherMap API.",
    sourceCode: "https://bitbucket.org/Kabocha23/react-weather/src/master/",
    liveDemo: "",
  },
  {
    id: 1,
    title: "Learn in a Flash",
    headline: "Flashcard App",
    caption: "React, Firebase Realtime Database",
    image: "react-flashcards-app",
    description:
      "A CRUD application allowing you to create virtual flash cards \n Features include: \n- A card flipping feature on mouseover \n- Built with React and Firebase Realtime Database to help you study \n- (Live demo currently set up for chinese chaaracters)",
    sourceCode: "https://bitbucket.org/Kabocha23/react-flashcards/src/master/",
    liveDemo: "https://reactflashcards-fb1d7.firebaseapp.com/",
  },
  {
    id: 2,
    title: "Notes!",
    headline: "Note keeping app",
    caption: "React, Firebase Realtime Database",
    image: "react-notes-app",
    description:
      "A CRUD application for keeping notes \nBuilt with React and Firebase Realtime Database to help you keep reminders",
    sourceCode: "https://bitbucket.org/Kabocha23/react-notes/src/master/",
    liveDemo: "",
  },
  {
    id: 3,
    title: "Sunnyside Agency",
    headline: "Graphic Design Company Homepage",
    caption: "React",
    image: "sunnyside-preview",
    description: "A responsive web design for a fictional creative agency",
    sourceCode: "https://github.com/kabocha23/Sunnyside-Agency-Site",
    liveDemo: "",
  },
  {
    id: 4,
    title: "Room",
    headline: "Furniture Store Homepage",
    caption: "React",
    image: "room-preview",
    description:
      "A responsive web design homepage for a fictional furniture company. \nFeatures include: \n- Navbar transitioning to hidden menu (sliding in from top) \n- Slideshow gallery component",
    sourceCode: "https://github.com/kabocha23/Room-Homepage",
    liveDemo: "https://kabocha23.github.io/Room-Homepage",
  },
  {
    id: 5,
    title: "Insure",
    headline: "Insurance Company Landing Page",
    caption: "React",
    image: "insure-preview-1",
    description:
      "A responsive landing page for a fictional insurance company \nFeatures include: \n- Navbar transitioning to hidden menu (sliding in from side)",
    sourceCode: "https://github.com/kabocha23/Insure-Landing-Page",
    liveDemo: "https://kabocha23.github.io/Insure-Landing-Page",
  },
  {
    id: 6,
    title: "Sneakers",
    headline: "E-commerce Product Page",
    caption: "React",
    image: "sneakers2",
    description:
      "A responsive product page web design for a fictional e-commerce website Sneakers Company. \nFeatures include: \n- Navbar transitioning to collapsible sidebar \n- Selectable photo gallery \n- Cart with CRUD functionality \n- Live cart quantity bubble",
    sourceCode: "https://github.com/kabocha23/Ecommerce-Product-Page",
    liveDemo: "https://kabocha23.github.io/Ecommerce-Product-Page",
  },
  {
    id: 7,
    title: "Indecisive Eaters",
    headline: "An app for anyone that just can't decide",
    caption:
      "React, Node, Express, Yelp-Fusion API, Axios, React DnD, reactjs-popup",
    image: "indecisive-eaters1",
    description:
      "A web application made for those who can't decide where to eat. \n- Search for restaurants with Yelp-Fusion API \n- Drag the desired restaurants to the list on the right. \n- When you're ready, click 'Decide for me!' and the app will randomly chose from your list!",
    sourceCode: "https://github.com/kabocha23/Indecisive",
    liveDemo: "https://whispering-forest-79782.herokuapp.com",
  },
  {
    id: 8,
    title: "IP Finder",
    headline: "An app for those curious of their IP Location",
    caption: "React, Leaflet Maps API, Ipify API, Axios",
    image: "ip_finder_preview",
    description:
      "A responsive web application that allows the user to extract general information from a public ip address. \n- Input allowing user to search for the location, timezone, and ISP of any public IP Address \n(Leaving the input blank will search the user's IP Address) \n- Have the IP geolocation pinned on an interactive map \n- Responsive web/mobile design",
    sourceCode: "https://github.com/kabocha23/ip-finder",
    liveDemo: "https://kabocha23.github.io/ip-finder",
  },
  {
    id: 9,
    title: "Shortly",
    headline: "A URL Shortening Application",
    caption: "React, Shrtcode API, Axios",
    image: "shortly-preview",
    description:
      "A responsive web application that shortens the user's URL by tapping into the Shrtcode API. \nFeatures include: \n- Input allowing user to make API call and shorten any url \n- Dynamically generated search history list with copy to clipboard button \n- Navbar transitioning to hidden menu (sliding in from top) \n- Responsive design for web and mobile",
    sourceCode: "https://github.com/kabocha23/URL-Shortener",
    liveDemo: "https://kabocha23.github.io/URL-Shortener",
  },
  {
    id: 10,
    title: "Space Tourism",
    headline: "A Multi-page Space Tourism Design",
    caption: "TypeScript, React, React Router",
    image: "space-tourism-preview",
    description:
      "A responsive web application design, created for a fictional space tourism company. \nFeatures include: \n- Responsive design for Desktop, Tablet, and Mobile \n- Multiple pages with custom nav menus within each page \n- Navbar transitioning to hidden menu (sliding in from side)",
    sourceCode: "https://github.com/kabocha23/space-tourism",
    liveDemo: "https://kabocha23.github.io/space-tourism",
  },
];

export default projectsData;
